import { useState , useEffect } from 'react';
import { useToast } from '../../context/ToastProvider.js';
import config from '../../constants/config.js';
import './../../styles/Modal.css';

function SaveProductModal({
    onClose,
    onSaveFinish,
    layerConfig,
    productHandle,
    shops
}) {
    const addToast = useToast();
    const statuses = [ 'Published', 'Draft' ];
    
    const [ versionName, setVersionName ] = useState( generateDefaultVersionName( productHandle ) );
    const [ loading , setLoading ] = useState( false );
    const [ status, setStatus ] = useState( statuses[1] );
    const [ selectedShops, setSelectedShops ] = useState( [] );

    const handleCheckboxChange = ( shopDomain ) => {
        setSelectedShops( ( prev ) => {
            let isSelected = false;

            for ( let i = 0; i < prev.length; i++ ) {
                if ( prev[i] === shopDomain ) {
                    isSelected = true;
                    break;
                }
            }

            if ( isSelected && prev.length === 1 ) {
                return prev;
            }

            const newSelection = [];
            if ( isSelected ) {
                for ( let i = 0; i < prev.length; i++ ) {
                    if ( prev[i] !== shopDomain ) {
                        newSelection.push( prev[i] );
                    }
                }
            } else {
                for ( let i = 0; i < prev.length; i++ ) {
                    newSelection.push( prev[i] );
                }
                newSelection.push( shopDomain );
            }

            return newSelection;
        });
    };

    useEffect(() => {
        if ( status === "Published" && selectedShops.length === 0 && shops.length > 0 ) {
            setSelectedShops( [ shops[0].shop ] );
        }
    }, [ status, shops ] );

    async function saveProductPersonalization( ) {
        setLoading( true );

        const payload = {
            personalizationConfig: layerConfig,
            versionConfig: {
                name: versionName, 
                status: status, 
                related_product_handle: productHandle
            },
            shops: selectedShops
        };

        let fData = null;
        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/products/${encodeURIComponent(productHandle)}/personalization`;
            const requestSettings = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( payload )
            };

            const response = await fetch( url , requestSettings );
            const data = await response.json();
            if ( data?.errors?.length > 0 ) {
                addToast( `Failed to add version - ${data?.errors[0].message}`, true , 5000 );
                fData = data;
            } else {
                addToast( `Added Version "${versionName}"`, false , 5000 );
                fData = data;
            }
        } catch ( error ) {
            console.log( error );
        }

        setLoading( false );
        if ( onSaveFinish ) {
            onSaveFinish( fData );
        }

        return;
    }

    function generateDefaultVersionName( handle ) {
        const now = new Date();

        const timestamp = now
            .toISOString()
            .replace(/T/, '_')
            .replace(/:/g, '-')
            .replace(/\..+/, '');

        return `${handle}_v_${timestamp}`;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h1>Save Product Personalization</h1>

                <div className="form-group">
                    <label>Version Name<span className="required-asterisk">*</span></label>
                    <input type="text" value={versionName} onChange={ e => setVersionName(e.target.value) } />
                </div>

                <div className="form-group">
                    <label>Status<span className="required-asterisk">*</span></label>
                    <select value={status} onChange={ e => setStatus(e.target.value) }>
                        {statuses.map(s => (
                        <option key={s} value={s}>{s}</option>
                        ))}
                    </select>
                </div>

                {status === "Published" && (
                    <div className="form-group">
                        <label>Select Shops<span className="required-asterisk">*</span></label>
                        <div className="shop-checkboxes">
                        {shops.map((shop) => (
                            <div key={shop.id} className="checkbox-option">
                                <input
                                    type="checkbox"
                                    id={`shop-${shop.id}`}
                                    value={shop.shop}
                                    checked={selectedShops.includes(shop.shop)}
                                    disabled={
                                        selectedShops.length === 1 && selectedShops.includes(shop.shop)
                                    }
                                    onChange={() => handleCheckboxChange(shop.shop)}
                                />
                                <label htmlFor={`shop-${shop.id}`}>{shop.nickname}</label>
                            </div>
                        ))}
                        </div>
                    </div>
                )}

                <div className="modal-controls">
                    <button disabled={loading} type="button" className="cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="done-btn"
                        disabled={loading}
                        onClick={ saveProductPersonalization }
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SaveProductModal;